import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const DrManjitSinghSidhuPage = () => (
  <Layout>
    <SEO title="Dr Manjit Singh Sidhu" />
    <h1>Dr Manjit Singh Sidhu</h1>
    <h3>Professional Qualifications</h3>
    <ul>
      <li>MBBS: Armed Forces Medical College (AFMC), Pune.</li>
      <li>MD (Obstetrics and Gynaecology): AFMC Pune, Poona University.</li>
      <li>DNB (Diplomate National Board): National Academy of Medical Sciences, New Delhi.</li>
    </ul>
    <h3>Additional Specialized Training</h3>
    <ul>
      <li><strong>Ultrasound:</strong> AFMC Pune. </li>
      <li><strong>Laparoscopic and Hysteroscopic Surgery:</strong> AFMC Pune.</li>
      <li><strong>Gynaecological Oncology:</strong> AFMC (Pune), Army Hospital (R&R) and CH(EC) Calcutta. </li>
      <li><strong>Advanced Vaginal Hysterectomy:</strong> Bombay Hospital, Mumbai.</li>
      <li><strong>Infertility and IVF:</strong> Army Hospital (R&R), New Delhi and IRMIC, Primus Hospital, New Delhi.</li>
      <li><strong>Urogynaecology and Fistula Repair:</strong> AFMC and CH(CC) Lucknow.</li>
    </ul>
    <h3>Professional Experience</h3>
    <ul>
      <li>Internship: Command Hospital(WC), Chandigarh.</li>
      <li>Early Military Experience:
        <ul>
          <li>Regimental Medical Officer: Having volunteered for a tough posting despite a recent fracture in foot, landed in the forefront of the battle in Sri Lanka as part of IPKF.  Working as Regimental Medical Officer was involved closely with onsite primary healthcare of troops and casualty evacuation of injured. Voluntarily doing infantry officer duties and taking active part in the guerilla warfare in the jungles and lagoons of Batticaloa Sector, it was a unique experience in life with lessons in grit, teamwork, leadership and quick decision-making though it sometimes brought one face to face with death.</li>
          <li>Provided primary health care as well as preventive healthcare checkups and planning for the over 4000 troops under responsibility as a Regimental Medical Officer in the deserts of Rajasthan during peacetime.</li>
        </ul>
      </li>
      <li>Post Graduation:
        <ul>
          <li>Qualified for entrance to Post Graduation through the tough qualifying examination securing 3rd rank in the national army candidates list. Dr Sidhu had a wish to serve the underprivileged and often neglected gender which constitutes half of the human race and at the same time pursue a career in a surgical field. So chose Obstetrics and Gynaecology as the subject of first choice when he had all the choices available.</li>
          <li>Did MD in Obstetrics and Gynaecology at Armed Forces Medical College (AFMC), Pune.</li>
        </ul>
      </li>
      <li>Experience as a Specialist in Gynaecology
        <ul>
          <li>
            Worked as Consultant Gynaecologist (Classified Specialist/Graded Specialist) on permanent posting at various hospitals including,
            <ul>
              <li>Command Hospital Pune</li>
              <li>Command Hospital Calcutta.</li>
              <li>Military Hospital, Faizabad.</li>
              <li>174 MH (Bathinda).</li>
              <li>Military Hospital, Kota.</li>
            </ul>
          </li>
          <li>
            Further worked in various hospitals on specialist duties as consultant and performing all surgeries and procedures at,
            <ul>
              <li>Command Hospital (CC), Lucknow,</li>
              <li>Base Hospital, New Delhi,</li>
              <li>Military Hospital, Allahabad,</li>
              <li>Military Hospital, Namkum (Ranchi),</li>
              <li>Military Hospital, Jodhpur,</li>
              <li>Military Hospital, Nasirabad.</li>
              <li>Operation Dhanwantry, Hospital on Wheels</li>
            </ul>
          </li>
          <li>Said goodbye to the service at the Rank of Lieut Colonel.</li>
          <li>Corporate Hospital experience:
          <ul><li>Worked as Principal Consultant and Head of Department at Max Hospital Bathinda</li></ul>
          </li>
          <li>
            Medical College experience
            <ul><li>Worked as Assistant Professor in Obstetrics and Gynaecology at Adesh Medical College Bathinda.</li></ul>
          </li>
        </ul>
      </li>
    </ul>
    <h3>Professional Memberships (Past and Present)</h3>
    <ul>

      <li>MNAMS: Member of National Academy of Medical Sciences.</li>
      <li>FOGSI: (Federation of Obstetric and Gynaecology Societies of India.</li>
      <li>BOGS: Bathinda Obstetrics and Gynaecology Society.
        <ul>
          <li>Have been the key person in getting everyone together, setting up the Society, getting it national affiliation to FOGSI and running it since its inception.</li>
          <li>Founder President of the BOGS since inception till date for the last four years.</li>
          <li>Presently, BOGS has grown into a vibrant and active professional society with over 50 gynaecologist members of Bathinda and surroundings and has regular CME with state and national level speakers and other activities.</li>
          <li>Regular speaker at Bathinda OBG Society and invited speaker at other society meetings.</li>
        </ul>
      </li>
      <li>KOGS (Kota Obstetric and Gynaecology Society):
        <ul>
          <li>Have been a member of KOGS from Year 2000 to 2004. Was Secretary of the Society for year 2002.</li>
        </ul>
      </li>
      <li>SFM (Society of Foetal Medicine): Life member</li>
      <li>AGOI (Association of Gynaecologic Oncologists of India): Life Member</li>
      <li>GESI (Gynaecologic Endocrinology Society of India): Life member</li>
      <li>ISGPS (International Society of Gynae Plastic surgeons): Life member</li>
      <li>IFS (Indian Fertility Society): Life Member</li>
      <li>ESHRE (European Society of Human Reproduction and Embryology)</li>
      <li>IMA (Indian Medical Association): Life member.</li>
      <li>IMA Bathinda: Have been the Secretary of the Society for the year 2007.
        <ul>
          <li>Organized district and state level actions when local sonologists were unduly and wrongly harassed with false cases under the PNDT.</li>
        </ul>
      </li>
      <li>IMA Punjab: Former Chairman of the PNDT Committee of the State IMA
        <ul>
          <li>In this tenure, Dr Sidhu authored and put up recommendations for simplification of ‘Form F’ under the PCPNDT Act to the National Advisory Committee on PCPNDT, Health Ministry, FOGSI and National IMA. The same was accepted with minor modifications and converted into a national law and till date it is the only amendment to the Form F in the 24 years of its existence.</li>
        </ul>
      </li>
    </ul>
    <h3>Personal Achievements and Milestones</h3>
    <ul>
      <li>ULTRASOUND:
        <ul>
          <li>Did extensive work on ultrasound and wrote a thesis on Ultrasound based management in pregnancy bleeding in 1991-92. Have been associated with and working on ultrasound since then.</li>
        </ul>
      </li>
      <li>LAPAROSCOPY:
        <ul>
          <li>Learnt laparoscopy during PG training in AFMC Pune in 1991- 92. Have been doing it since then. </li>
          <li>Started pioneering operative laparoscopic work in Bathinda in 1999 while at Military Hospital.</li>
        </ul>
      </li>
      <li>Hysteroscopy:
        <ul>
          <li>Received hands on Hysteroscopy training during PG study when it was being introduced in the country.</li>
          <li>Have been doing advanced operative hysteroscopic work for over two decades.</li>
        </ul>
      </li>
      <li>Vaginal Hysterectomy:
        <ul>
          <li>Was one of the pioneers of Non Descent Vaginal Hysterectomy in the Armed Forces in 1996-97.</li>
          <li>Introduced Non Descent Vaginal hysterectomy in Bathinda in 1997 when it was unheard of in North India.</li>
          <li>Did a record over 50 cases of NDVH at Military Hospital, Bathinda in 1999 which was the highest at any hospital or institute in north of Delhi at that time (to the best of our knowledge).</li>
        </ul>
      </li>
      <li>Gynaecology Surgery:
        <ul><li>Undertook 13 major cases at a stretch in a single session at Military Hospital, Kota which was quite a high number for a small Army setup with a single gynaecologist, a single anaesthesiologist and a single OT team working non-stop in a single OT.</li></ul>
      </li>
      <li>Infertility:
        <ul>
          <li>Have been doing fertility enhancing surgery (both endoscopic and open) for over last two decades.</li>
          <li>Expert in finding affordable solutions infertility management with diagnostics, drugs and endocrine correction.</li>
        </ul>
      </li>
      <li>Operation Dhanwantari (Hospital on Wheels):
        <ul>
          <li>This mission has a place of honour in the Guinness Book of World Records. </li>
          <li>The Indian Army, on the occasion of the 50th Anniversary of the Indian Independence, undertook a unique mission to provide medical care (including surgical operations) to the vast number of retired army personnel settled in various remote parts of the country. For this purpose one full train of the Indian Railways was converted into a mobile hospital with all facilities including medical consultation, examination, admission, nursing care and surgical procedures. The train was self-sufficient with complete arrangement of food and lodging of all the staff on the train itself and was a designated army unit. </li>
          <li>The journey included traversing the length and breadth of the country and especially focusing on remote areas and areas with less army establishments. The journey started from New Delhi and covered different states including Rajasthan, Gujarat, Maharashtra, Karnataka, Goa, Kerala, Tamilnadu, Andhra Pradesh, Orissa, Bihar, West Bengal and Uttar Pradesh.</li>
          <li>I was the Specialist Gynaecologist on board this unique Mission during its maiden journey in 1997. Provided medical care and performed surgeries such as CPT repair even in the remote areas such as Dhrangadhra in Gujarat.</li>
        </ul>
      </li>
      <li>PCPNDT Act:
        <ul>
          <li>PCPNDT Act is a Central Act which was passed in 1994, effected throughout India in 1996 but actually implemented strictly only in 2003 onwards. The Act was made with the intention of putting an end to the practice of sex determination and to save the girl child in the womb.</li>
          <li>However, instead of focusing on action against those doing sex determination, this Act has led to action against the sonologists on flimsy grounds and clerical errors. This problem was exacerbated by the ambiguities in the Act which leave everyone guessing as to how to follow the Act correctly.</li>
          <li>As the President of Bathinda Obst and Gynae Society and as Acting Chairman of the PNDT Committee of IMA Punjab, I authored a list of suggestions for changes in the Form F to make it simpler and clearer from the point of view of the sonologists without affecting its importance. </li>
          <li>These changes were forwarded to the Health Minister, the MOHFW as well as to FOGSI and National IMA.</li>
          <li>Most of these changes were accepted as such and as a result of implementation of these changes the PCPNDT Act underwent major amendment which was effected through a notification dated 31 January 2014 all over the country. This remains the only amendment in the Form F brought in the 22 years of its existence. </li>
          <li>This amendment resulted in new Form F which has been very much appreciated by the Gynaecologist and Radiologist community as it has markedly reduced the paperwork as well as led to much less number of cases against doctors on flimsy grounds.  </li>
        </ul>
      </li>
      <li>Private Practice:
        <ul>
          <li>Established Preet Hospital along with my wife Dr Preeti Sidhu in 2007 in a spacious, modern well planned building. It is unique, largest till date, well equipped Single Specialty Hospital for Obstetrics and Gynaecology in Bathinda.  </li>
          <li>The hospital has a reputation for quality care in its field. One of the highest numbers of deliveries among all private hospitals in the region have been conducted here including High risk pregnancy care and complicated delivery cases. Advanced surgeries such as NDVH, Laparsoscopic hysterectomy, gynaecologic cancer surgery, operative endoscopic surgery and urinary fistula repair surgeries have been done here routinely. </li>
        </ul>
      </li>
    </ul>
  </Layout>
)

export default DrManjitSinghSidhuPage
